// extracted by mini-css-extract-plugin
module.exports = {"shapes":"AddShapeControl_shapes__sHcpa"};